import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-procurement',
    templateUrl: './procurement.component.html',
    styleUrls: ['./procurement.component.scss'],
    standalone: false
})
export class ProcurementComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
